var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-screen"},[_c('GroupsFilter'),_c('MainGroups',{attrs:{"groups-data":_vm.getGroupsData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }